module.exports = __webpack_public_path__ + "media/images/glass-services-2-d47fce03a94e04db1a6d93f7826a3f18.jpg";